import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import { FocusThemeProvider } from "./theme/FocusThemeContext";
import LoadingScreen from "./components/LoadingScreen";

import Vitaelum from "./pages/projects/Vitaelum";
import JobMatch from "./pages/projects/Jobmatch";
import Nirilium from "./pages/projects/Nirilium";
import Arenav2 from "./pages/projects/Arenav2";
import Styleguide from "./pages/Styleguide";

function App() {
  return (
    <FocusThemeProvider>
      <LoadingScreen />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects/vitaelum" element={<Vitaelum />} />
          <Route path="/projects/jobmatch" element={<JobMatch />} />
          <Route path="/projects/nirilium" element={<Nirilium />} />
          <Route path="/projects/arenav2" element={<Arenav2 />} />
          <Route path="/styleguide" element={<Styleguide />} />
        </Routes>
      </Router>
    </FocusThemeProvider>
  );
}

export default App;
